export enum AlertTypes {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}
